import { StandingOrdersController } from './standingOrders.controller';
import template from './standingOrders.html';

export const standingOrdersComponent = {
  name: 'standingOrdersComponent',
  restrict: 'E',
  template,
  controller: StandingOrdersController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<',
    ticketId: '<',
    standingOrdersAndAppointmentTransfers: '<',
  },
};
